module.exports = __webpack_public_path__ + "static/img/8bg_11.0ea4427.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_11.png
// module id = 758
// module chunks = 1